import { User } from "../user";

export class PositionResponse {
  public id: string;
  public name: string;
  public createdBy: User;
  public createdAt: any;
  public updatedAt: any;
  public isGlobal?: boolean;
  public isOrganizational?: boolean;
}